import { useMutation } from '@tanstack/react-query';
import indicateActionPlatformNumber from '@/API/PlatformNumber/indicateActionPlatformNumber';

const useIndicateMultiActionPlatform = (
    numbers,
    scope,
    setIsConfirming,
    refetchTableData,
) => {
    return useMutation({
        mutationFn: async () => {
            try {
                const res = await Promise.all(
                    numbers.map(async (number) => {
                        return await indicateActionPlatformNumber(
                            number.numberID,
                            number.platformID,
                            scope,
                        );
                    }),
                ).then(() => {
                    setIsConfirming(false);
                    refetchTableData();
                });

                return res;
            } catch (error) {
                throw new Error(
                    error?.message || 'Failed to update platform numbers',
                );
            }
        },
    });
};

export default useIndicateMultiActionPlatform;
